export default "__VITE_ASSET__BlVsY1JQ__"